module.exports = __webpack_public_path__ + "img/3.052c52ac.png";